/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  vehicules: {
    brands: [],
  },
};

export const tecdocSlice = createSlice({
  name: 'tecdoc',
  initialState,
  reducers: {
    setVehiculesBrands: (state, action) => {
      state.vehicules.brands = action.payload;
    },
  },
});

export const { setVehiculesBrands } = tecdocSlice.actions;

export default tecdocSlice.reducer;
